import globals from '../globals';
export default {
    data() {
        return {
            warning_msg:"",
        }
    },
    methods: { 
        async createSurveyForm(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_SALES_URL + "/survey_forms/", params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                        this.disable_save = false;
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    reject(error.response.data.reason)
                    this.disable_save = false;
                    //this.warning_msg = sessionStorage.getItem("error")
                    // this.warning_msg = error.response.data.reason
                    // this.$refs.warning_modal.open();
                    // setTimeout(() => {
                    //     this.$refs.warning_modal.close();
                    // }, 3000);
                }
            })
        },
        async sendSurveyForm(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_SALES_URL + `/survey_forms/send`, params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.data.reason)
                    }
                }
                catch(error){
                    reject(error.response.data.reason)
                }
            })
        },
        async getSurveyForm(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.get(globals.CRM_SALES_URL + `/survey_forms/?skip=${params.skip}&limit=${params.limit}&search=${params.search}`)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getSurveyFormQuestionTypes() {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.get(globals.CRM_SALES_URL + "/survey_forms/question/types/dropdown")
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getSurveyFormTypesDropdown(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.get(globals.CRM_SALES_URL + `/survey_forms/types/dropdown?limit=${params.limit}&skip=${params.skip}&search_key=${params.search_key}`)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getSurveyFormById(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.get(globals.CRM_SALES_URL + "/survey_forms/"+params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async updateSurveyFormById(params, id) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.patch(globals.CRM_SALES_URL + `/survey_forms/${id}`, params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getIndustryTypeDropdown(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.get(globals.AUTH_SERVICE + `/company/settings?type=${params.type}&skip=${params.skip}&limit=${params.limit}&search_key=${params.search_key}`)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getProductTypeDropdown(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.post(globals.CRM_SALES_URL + `/products/list`, params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getSurveyFormResponseByType(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.get(globals.CRM_SALES_URL + `/survey_forms/answers?form_id=${params.form_id}&skip=${params.skip}&response_type=${params.response_type}`)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getSurveyFormAnswerById(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.get(globals.CRM_SALES_URL + `/survey_forms/answers/${params.question_id}?limit=${params.limit}&skip=${params.skip}&search_key=${params.search_key}`)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        this.ajax_call_in_progress = false;
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    this.ajax_call_in_progress = false;
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async getSurveyFormSettingsById(params) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.get(globals.CRM_SALES_URL + `/survey_forms/settings/${params}`)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async updateSurveyFormSettingsById(params, id) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.patch(globals.CRM_SALES_URL + `/survey_forms/settings/${id}`, params)
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
        async deleteSurveyFormById(id) {
            return new Promise(async (resolve, reject) => {
                try{
                    let response = await this.$http.delete(globals.CRM_SALES_URL + `/survey_forms/delete`, {
                        data: id
                    })
                    if (response.data.status_id == 1) {
                        resolve(response.data)
                    } else {
                        reject(response.reason)
                        this.warning_msg = response.data.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                }
                catch(error){
                    this.warning_msg = error.response.data.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            })
        },
    }
}


// WEBPACK FOOTER //
// ./src/components/mixins/survey_forms.js